import { useEffect, useState } from "react";
import Footer from "../component/Footer/FooterCommon";
import Navbar from "../component/Navbar/NavbarCommon";
import { ExternalLink } from "lucide-react";
import { useSearchParams } from "react-router-dom";

const portalLinks = [
  {
    country: "India",
    url: "https://india.company-portal.com",
    label: "Visit Indian Portal",
  },
  {
    country: "Bangladesh",
    url: "https://bangladesh.company-portal.com",
    label: "Visit Bangladesh Portal",
  },
  {
    country: "Sri Lanka",
    url: "https://srilanka.company-portal.com",
    label: "Visit Sri Lanka Portal",
  },
];

// Corporate office addresses for each location
const corporateOffices: Record<
  string,
  { name: string; address: string[]; mapLink: any; phone: string}
> = {
  bangalore: {
    name: "CORPORATE OFFICE",
    phone: "080-28011200",
    mapLink: "https://maps.app.goo.gl/JYwdr46umgsDxxV66",
    address: [
      "A O SMITH INDIA WATER PRODUCTS PRIVATE LIMITED",
      "300, Phase II, KIADB INDL AREA,",
      "HAROHALLI, KANAKAPURA (TQ),",
      "RAMANAGARA (DIST) - 562112.",
    ],
  },
  mumbai: {
    name: "MUMBAI OFFICE",
    phone: "080-28011200",
    mapLink: "https://maps.app.goo.gl/iAn5XxWJsoZah6FTA",
    address: [
      "A O SMITH INDIA WATER PRODUCTS PRIVATE LIMITED",
      "Unit Nos. 501 to 508, 5th Floor, Everest Chambers,",
      "C.T.S. Nos. 794, 794/1 to 5, Marol Naka,",
      "Andheri Kurla Road, Andheri (East),",
      "Mumbai – 400059",
    ],
  },
  dhaka: {
    name: "CORPORATE OFFICE",
    phone: "+880-02-8870780, +880-02-8870781 ",
    mapLink: "https://maps.app.goo.gl/FAoLjhAqtQvXiRh86",
    address: [
      "A O SMITH BANGLADESH WATER PRODUCTS PRIVATE LIMITED",
      "Rangs Babylonia, 246 Bir Uttam Mir Shawkat Road,",
      "Tejgaon I/A, Dhaka-1208, Bangladesh",
    ],
  },
  colombo: {
    name: "CORPORATE OFFICE",
    phone: "080-28011200",
    mapLink: "https://maps.app.goo.gl/JYwdr46umgsDxxV66",
    address: [
      "A O SMITH SRILANKA WATER PRODUCTS PRIVATE LIMITED",
      "97A, Galle Road, Colombo 03, 00300 Sri Lanka",
    ],
  },
};

const ContactUs = () => {
  const [searchParams] = useSearchParams();
  const location = searchParams.get("location") || "bangalore";
  const [currentOffice, setCurrentOffice] = useState(
    corporateOffices[location]
  );

  useEffect(() => {
    const office = corporateOffices[location] || corporateOffices.bangalore;
    setCurrentOffice(office);
  }, [location]);
  return (
    <div className="min-h-screen h-auto w-full flex flex-col bg-gray-200 font-poppins">
      {/* Navbar */}
      <div className="flex-shrink-0">
        <Navbar />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col lg:flex-row overflow-y-auto overflow-x-hidden">
        {/* Desktop Layout */}
        <div className="hidden lg:flex w-full h-auto overflow-hidden">
          {/* Left Background */}
          <div className="w-1/2 relative bg-white/75 flex overflow-hidden mt-[120px]">
            <img
              src="assets/bg-contact-us.svg"
              alt="Contact Us Background"
              className="w-full h-full object-contain lg:object-cover opacity-70"
            />
          </div>

          {/* Right Content */}
          <div className="w-1/2 lg:min-h-full lg:h-auto flex justify-center bg-white/50 px-4 overflow-y-auto pt-40 overflow-hidden">
            <div className="w-full max-w-sm xl:max-w-md 2xl:max-w-lg mx-auto flex flex-col justify-start space-y-2">
              {/* CORPORATE OFFICE */}
              <div className="bg-white rounded-lg p-2.5 shadow-sm contact-card">
                <h2 className="text-xs xl:text-sm font-semibold text-black mb-1">
                  {currentOffice.name}
                </h2>
                <div className="flex items-start space-x-2.5">
                  <img
                    src="assets/location.svg"
                    alt="Location"
                    className="w-3.5 h-3.5 mt-0.5"
                  />
                  <div className="text-black text-xs leading-tight space-y-0.5 ">
                    {currentOffice.address.map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                    <div>
                     <button onClick={()=>{
                        window.open(currentOffice?.mapLink,"_blank")
                      }} className="text-navgreen hover:text-green-700 text-xs transition-colors">Get Directions</button>
                    </div>
                  </div>
                </div>
              </div>

              {/* CITY OFFICE - Only for Bangalore */}
              {location === "bangalore" && (
                <div className="bg-white rounded-lg p-2.5 shadow-sm contact-card">
                  <h2 className="text-xs xl:text-sm font-semibold text-black mb-1">
                    CITY OFFICE
                  </h2>
                  <div className="flex items-start space-x-2.5">
                    <img
                      src="assets/location.svg"
                      alt="Location"
                      className="w-3.5 h-3.5 mt-0.5"
                    />
                    <div className="text-black text-xs leading-tight space-y-0.5">
                      <div>A O SMITH INDIA WATER PRODUCTS PRIVATE LIMITED</div>
                      <div>
                        4th Floor, IMG Tower, 18, 80 Feet Rd, S.T. Bed, 4th
                        Block, Koramangala, Bengaluru, Karnataka 560047
                      </div>
                      <button onClick={()=>{
                        window.open("https://maps.app.goo.gl/RhTx1wRQa74MiyKK7","_blank")
                      }} className="text-navgreen hover:text-green-700 text-xs transition-colors">Get Directions</button>
                    </div>
                  </div>
                </div>
              )}

              {/* REGIONAL OFFICES */}
              <div className="bg-white rounded-lg p-2.5 shadow-sm contact-card">
                <h2 className="text-xs xl:text-sm font-semibold text-black mb-1">
                  REGIONAL OFFICES
                </h2>
                <div className="space-y-1">
                  <div className="flex items-start space-x-2.5">
                    {location === "bangalore" && (
                      <img
                        src="assets/location.svg"
                        alt="Location"
                        className="w-3.5 h-3.5 mt-0.5"
                      />
                    )}
                    <div
                      className={`text-black text-xs ${
                        location !== "bangalore" ? "pl-6" : ""
                      }`}
                    >
                      Bangalore - IND
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5">
                    {location === "mumbai" && (
                      <img
                        src="assets/location.svg"
                        alt="Location"
                        className="w-3.5 h-3.5 mt-0.5"
                      />
                    )}
                    <div
                      className={`text-black text-xs ${
                        location !== "mumbai" ? "pl-6" : ""
                      }`}
                    >
                      Mumbai - IND
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5">
                    {location === "dhaka" && (
                      <img
                        src="assets/location.svg"
                        alt="Location"
                        className="w-3.5 h-3.5 mt-0.5"
                      />
                    )}
                    <div
                      className={`text-black text-xs ${
                        location !== "dhaka" ? "pl-6" : ""
                      }`}
                    >
                      Dhaka - BGD
                    </div>
                  </div>
                  <div className="flex items-start space-x-2.5">
                    {location === "colombo" && (
                      <img
                        src="assets/location.svg"
                        alt="Location"
                        className="w-3.5 h-3.5 mt-0.5"
                      />
                    )}
                    <div
                      className={`text-black text-xs ${
                        location !== "colombo" ? "pl-6" : ""
                      }`}
                    >
                      Colombo - LKA
                    </div>
                  </div>
                </div>
              </div>

              {/* CONTACT NUMBER */}
              <div className="bg-white rounded-lg p-2.5 shadow-sm contact-card">
                <h2 className="text-xs xl:text-sm font-semibold text-black mb-1">
                  CONTACT NUMBERS
                </h2>
                <div className="space-y-0.5">
                  <div className="flex items-center space-x-2.5">
                    <img
                      src="assets/call.svg"
                      alt="Phone"
                      className="w-3.5 h-3.5"
                    />
                    <a
                      href={`tel:${currentOffice.phone}`}
                      className="text-black hover:text-navgreen text-xs transition-colors"
                    >
                      {currentOffice.phone}
                    </a>
                  </div>
                  {/* <div className="pl-6">
                    <a href="tel:+919740452899" className="text-black hover:text-navgreen text-xs transition-colors">+91 9740452899</a>
                  </div> */}
                </div>
              </div>

              {/* PORTAL LINKS */}
              {/* <div className="bg-white rounded-lg p-2.5 shadow-sm contact-card">
                <h2 className="text-xs xl:text-sm font-semibold text-black mb-1">GET DIRECTION</h2>
                <div className="space-y-1.5">
                
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden relative w-full h-auto overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 z-0">
            <img
              src="assets/bg-contact-us.svg"
              alt="Contact Us Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40"></div>
          </div>

          {/* Content Container */}
          <div className="relative z-10 w-full min-h-screen flex flex-col justify-start pt-20 pb-10 px-4 overflow-y-auto">
            <div className="w-full max-w-sm mx-auto space-y-3">
              {/* CORPORATE OFFICE */}
              <div className="bg-white rounded-lg p-4 shadow-lg border border-gray-100 contact-card">
                <h2 className="text-sm font-bold text-gray-800 mb-2">
                  {currentOffice.name}
                </h2>
                <div className="flex items-start space-x-3">
                  <div className="w-4 h-4 mt-1">
                    <img src="assets/location.svg" alt="Location" />
                  </div>
                  <div className="text-gray-700 text-xs font-medium leading-relaxed">
                    {currentOffice.address.map((line, index) => (
                      <div key={index} className="mb-0.5">
                        {line}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* CITY OFFICE - Only for Bangalore */}
              {location === "bangalore" && (
                <div className="bg-white rounded-lg p-4 shadow-lg border border-gray-100 contact-card">
                  <h2 className="text-sm font-bold text-gray-800 mb-2">
                    CITY OFFICE
                  </h2>
                  <div className="flex items-start space-x-3">
                    <div className="w-4 h-4 mt-1">
                      <img src="assets/location.svg" alt="Location" />
                    </div>
                    <div className="text-gray-700 text-xs font-medium space-y-1">
                      <div>INCUBEX (THRIVE)</div>
                      <div>4TH FLOOR</div>
                      <button className="text-green-600 hover:text-green-700 text-xs font-semibold underline">
                        Get Directions
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* REGIONAL OFFICES */}
              <div className="bg-white rounded-lg p-4 shadow-lg border border-gray-100 contact-card">
                <h2 className="text-sm font-bold text-gray-800 mb-2">
                  REGIONAL OFFICES
                </h2>
                <div className="space-y-1.5">
                  <div className="flex items-start space-x-3">
                    {location === "bangalore" && (
                      <div className="w-4 h-4 mt-0.5">
                        <img src="assets/location.svg" alt="Location" />
                      </div>
                    )}
                    <div
                      className={`text-gray-700 text-xs font-medium ${
                        location !== "bangalore" ? "pl-7" : ""
                      }`}
                    >
                      Bangalore - IND
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    {location === "mumbai" && (
                      <div className="w-4 h-4 mt-0.5">
                        <img src="assets/location.svg" alt="Location" />
                      </div>
                    )}
                    <div
                      className={`text-gray-700 text-xs font-medium ${
                        location !== "mumbai" ? "pl-7" : ""
                      }`}
                    >
                      Mumbai - IND
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    {location === "dhaka" && (
                      <div className="w-4 h-4 mt-0.5">
                        <img src="assets/location.svg" alt="Location" />
                      </div>
                    )}
                    <div
                      className={`text-gray-700 text-xs font-medium ${
                        location !== "dhaka" ? "pl-7" : ""
                      }`}
                    >
                      Dhaka - BGD
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    {location === "colombo" && (
                      <div className="w-4 h-4 mt-0.5">
                        <img src="assets/location.svg" alt="Location" />
                      </div>
                    )}
                    <div
                      className={`text-gray-700 text-xs font-medium ${
                        location !== "colombo" ? "pl-7" : ""
                      }`}
                    >
                      Colombo - LKA
                    </div>
                  </div>
                </div>
              </div>

              {/* CONTACT NUMBERS */}
              {/* <div className="bg-white rounded-lg p-4 shadow-lg border border-gray-100 contact-card">
                <h2 className="text-sm font-bold text-gray-800 mb-2">CONTACT NUMBERS</h2>
                <div className="space-y-1.5">
                  <div className="flex items-center space-x-3">
                    <div className="w-4 h-4">
                      <img src="assets/call.svg" alt="Phone" />
                    </div>
                    <a
                      href="tel:080-28011200"
                      className="text-gray-700 hover:text-green-600 text-xs font-medium"
                    >
                      080-28011200
                    </a>
                  </div>
                  <div className="pl-7">
                    <a
                      href="tel:+919740452899"
                      className="text-gray-700 hover:text-green-600 text-xs font-medium"
                    >
                      +91 9740452899
                    </a>
                  </div>
                </div>
              </div> */}

              {/* PORTAL LINKS */}
              {/* <div className="bg-white rounded-lg p-4 shadow-lg border border-gray-100 mb-4 contact-card">
                <h2 className="text-sm font-bold text-gray-800 mb-2">PORTAL LINKS</h2>
                <div className="space-y-2">
                  {portalLinks.map((link, i) => (
                    <a
                      key={i}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 text-green-600 hover:text-green-700 underline text-xs font-medium"
                    >
                      <ExternalLink size={16} strokeWidth={1.5} />
                      <span>{link.label}</span>
                    </a>
                  ))}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex-shrink-0">
        <Footer />
      </div>
    </div>
  );
};

export default ContactUs;
